import { Edge } from 'react-flow-renderer';

export const buildEdge = (source: string, target: string): Edge => ({
  id: `e${source}${target}`,
  source,
  target,
  type: 'todoEdge',
});
